import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessPrinterSetupParamInterfaceStatus: 'idle',
    startProcessPrinterSetupParamInterfaceError: undefined as any,
    loadUserParamsProcessPrinterSetupParamInterfaceStatus: 'idle',
    loadUserParamsProcessPrinterSetupParamInterfaceError: undefined as any,

    processPrinterSetupParamInterfaceList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessPrinterSetupParamInterface = createAsyncThunk('processPrinterSetupParamInterfaceSlice/startProcessPrinterSetupParamInterface', async ({ processPrinterSetupParamInterface }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessPrinterSetupParamInterface/`,
        prepareData(processPrinterSetupParamInterface),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessPrinterSetupParamInterfaceStatus } = getState().processPrinterSetupParamInterfaceSlice
        return startProcessPrinterSetupParamInterfaceStatus !== 'pending'
    }
})

export const loadUserParamsProcessPrinterSetupParamInterface = createAsyncThunk('processPrinterSetupParamInterfaceSlice/loadUserParamsProcessPrinterSetupParamInterface', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessPrinterSetupParamInterface/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessPrinterSetupParamInterfaceStatus } = getState().processPrinterSetupParamInterfaceSlice
        return loadUserParamsProcessPrinterSetupParamInterfaceStatus !== 'pending'
    }
})

const ProcessPrinterSetupParamInterfaceSlice = createSlice({
    name: 'processPrinterSetupParamInterfaceSlice',
    initialState,
    reducers: {
        resetstartProcessPrinterSetupParamInterface: (state) => {
            state.job = undefined
            state.startProcessPrinterSetupParamInterfaceError = undefined
        },
        resetstartProcessPrinterSetupParamInterfaceError: (state) => {
            state.startProcessPrinterSetupParamInterfaceError = undefined
        },
        resetloadUserParamsProcessPrinterSetupParamInterface: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessPrinterSetupParamInterfaceError = undefined
        },
        resetloadUserParamsProcessPrinterSetupParamInterfaceError: (state) => {
            state.loadUserParamsProcessPrinterSetupParamInterfaceError = undefined
        },
        removeFromProcessPrinterSetupParamInterfaceListById: (state, action) => {
            state.processPrinterSetupParamInterfaceList = state.processPrinterSetupParamInterfaceList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessPrinterSetupParamInterfaceListByIds: (state, action) => {
            state.processPrinterSetupParamInterfaceList = state.processPrinterSetupParamInterfaceList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processPrinterSetupParamInterfaceList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessPrinterSetupParamInterfaceStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processPrinterSetupParamInterfaceList = []
            state.startProcessPrinterSetupParamInterfaceStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessPrinterSetupParamInterface.pending, (state) => {
            state.startProcessPrinterSetupParamInterfaceStatus = 'pending'
            state.startProcessPrinterSetupParamInterfaceError = undefined
        })
        builder.addCase(startProcessPrinterSetupParamInterface.fulfilled, (state, action) => {
            state.startProcessPrinterSetupParamInterfaceStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessPrinterSetupParamInterface.rejected, (state, action) => {
            state.startProcessPrinterSetupParamInterfaceStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessPrinterSetupParamInterfaceError = action.error.message
            } else {
                state.startProcessPrinterSetupParamInterfaceError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessPrinterSetupParamInterface.pending, (state) => {
            state.loadUserParamsProcessPrinterSetupParamInterfaceStatus = 'pending'
            state.loadUserParamsProcessPrinterSetupParamInterfaceError = undefined
        })
        builder.addCase(loadUserParamsProcessPrinterSetupParamInterface.fulfilled, (state, action) => {
            state.loadUserParamsProcessPrinterSetupParamInterfaceStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessPrinterSetupParamInterface.rejected, (state, action) => {
            state.loadUserParamsProcessPrinterSetupParamInterfaceStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessPrinterSetupParamInterfaceError = action.error.message
            } else {
                state.loadUserParamsProcessPrinterSetupParamInterfaceError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessPrinterSetupParamInterface,
    resetstartProcessPrinterSetupParamInterfaceError,
    resetloadUserParamsProcessPrinterSetupParamInterface,
    resetloadUserParamsProcessPrinterSetupParamInterfaceError,
    removeFromProcessPrinterSetupParamInterfaceListById,
    removeFromProcessPrinterSetupParamInterfaceListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessPrinterSetupParamInterfaceSlice.actions
export default ProcessPrinterSetupParamInterfaceSlice.reducer
